// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if ({ "index~0":1,"index~2":1,"index~21":1,"index~3":1,"index~4":1,"index~5":1,"index~6":1,"index~7":1,"index~8":1 }[chunkId]) return "static/css/" + chunkId + ".css";
  // return url for filenames based on template
  return "static/css/async/" + chunkId + ".css"
}